/**
 * 全局事件总线
 * 用于跨组件通信（非父子关系组件之间）
 * 使用方式：
 *   import EventBus from './event-bus'
 *   EventBus.$emit('event-name', payload)
 *   EventBus.$on('event-name', handler)
 *   EventBus.$off('event-name', handler)
 *
 * 事件列表：
 *   auth-changed  - 登录状态变化时触发（登录/退出/token过期）
 *   cart-changed  - 购物车数量变化时触发（加入/删除/修改数量）
 */
import Vue from 'vue'
const EventBus = new Vue()
export default EventBus
